<template>
  <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.crypto-jwt-sign') }}</div>
</template>

<script>
export default {
  name: 'JWTSignOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
